<style lang="less" scoped>
.verify_result{
	position: absolute;
	width: 100%;
	height: 100%;
	padding-bottom: 54px;
	box-sizing: border-box;
	display: -webkit-box; display:flex;
	-webkit-box-align: center; align-items: center;
	-webkit-box-pack: center; justify-content: center;
	flex-direction: column;
	.icon{
		width: 58px;
		margin-bottom: 22px;
	}
	h3{
		text-align: center;
		font-size: 18px;
		margin-bottom: 8px;
	}
	p{
		font-size: 12px;
		color: #999;
		padding-bottom: 80px;
		width: 55%;
		text-align: center;
		line-height: 18px;
	}
}
</style>

<template>
	<!-- Main verify_result -->
	<section class="verify_result">
		<img class="icon" src="../assets/success.png">
		<h3>已提交</h3>
		<p>银行将在1-2个工作日内审核，请关注账号信息变化</p>
		<footbtn btn-txt="完成" :is-on="isActive" v-on:next="next"></footbtn>
	</section>
</template>

<script>

	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import android from '@flyme/jr/js/android.js';

	export default {
		data: function () {
			return {
				identity: {
					status: ''
				},
				userInfo: {},
				loading: false
			};
		},
		computed: {
			isActive: function() {
				return true;
			},
			redirect() {
				return this.$route.query.redirect || 'Acctplus';
			}
		},
		components: {
			footbtn
		},
		created: function () {
			android('setTitle', {
				title: "开通余额+"
			});
		},
		methods: {
			next: function () {
				this.$router.replace({name: this.redirect});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Reverify_result.vue